export function isStringEmpty(value) {
  return isValueEmpty(value) || (typeof value === 'string' && value.trim() === '');
}

export function isValueEmpty(value) {
  return !value;
}
